import { render, staticRenderFns } from "./AndroidApks.vue?vue&type=template&id=1900a5e4&"
import script from "./AndroidApks.vue?vue&type=script&lang=js&"
export * from "./AndroidApks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports